import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { EquityMarketStatus } from '../types/EquityMarketAdminPanelContextType';

const statusConfig: Record<
  EquityMarketStatus,
  { icon: string; badge: string; labelKey: string }
> = {
  OPEN: { icon: 'ni-check-circle', badge: 'badge-success', labelKey: 'MarketStatusOpen' },
  CLOSED: { icon: 'ni-na', badge: 'badge-danger', labelKey: 'MarketStatusClosed' },
  UNAVAILABLE: { icon: 'ni-alert-circle', badge: 'badge-warning', labelKey: 'MarketStatusUnavailable' },
};

type EquityMarketStatusBadgeProps = {
  status: EquityMarketStatus;
};

const EquityMarketStatusBadge: FC<EquityMarketStatusBadgeProps> = ({
  status,
}) => {
  const { t } = useTranslate();
  const config = statusConfig[status];

  return (
    <span className={`badge ${config.badge}`}>
      <em className={`icon ni ${config.icon} mr-1`} />
      {t(config.labelKey)}
    </span>
  );
};

export default EquityMarketStatusBadge;
